import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import memoize from 'memoize-one';
import Icon from '@atlaskit/icon/glyph/checkbox';
import IconIndeterminate from '@atlaskit/icon/glyph/checkbox-indeterminate';
import GlobalTheme from '@atlaskit/theme/components';
import { IconWrapperOverrides } from './elements';
import Theme, { componentTokens } from './theme';
import { createExtender } from './utils';
var defaults = {
  IconWrapper: IconWrapperOverrides,
  IconIndeterminate: {
    component: IconIndeterminate
  },
  Icon: {
    component: Icon
  }
};

var CheckboxIcon = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxIcon, _Component);

  var _super = _createSuper(CheckboxIcon);

  function CheckboxIcon(props) {
    var _this;

    _classCallCheck(this, CheckboxIcon);

    _this = _super.call(this, props);
    _this.createExtender = memoize(createExtender).bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CheckboxIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isChecked = _this$props.isChecked,
          isDisabled = _this$props.isDisabled,
          isInvalid = _this$props.isInvalid,
          isActive = _this$props.isActive,
          isFocused = _this$props.isFocused,
          isHovered = _this$props.isHovered,
          isIndeterminate = _this$props.isIndeterminate,
          overrides = _this$props.overrides,
          primaryColor = _this$props.primaryColor,
          secondaryColor = _this$props.secondaryColor,
          theme = _this$props.theme; // @ts-ignore

      var getOverrides = this.createExtender(defaults, overrides);

      var _getOverrides = getOverrides('IconWrapper'),
          IconWrapper = _getOverrides.component,
          iconWrapperOverrides = _objectWithoutProperties(_getOverrides, ["component"]);

      var _getOverrides2 = getOverrides('IconIndeterminate'),
          IconIndeterminate = _getOverrides2.component;

      var _getOverrides3 = getOverrides('Icon'),
          Icon = _getOverrides3.component;

      return /*#__PURE__*/React.createElement(Theme.Provider, {
        value: theme
      }, /*#__PURE__*/React.createElement(GlobalTheme.Consumer, null, function (_ref) {
        var mode = _ref.mode;
        return /*#__PURE__*/React.createElement(Theme.Consumer, {
          mode: mode,
          tokens: componentTokens
        }, function (tokens) {
          return /*#__PURE__*/React.createElement(IconWrapper, _extends({}, iconWrapperOverrides, {
            tokens: tokens,
            isChecked: isChecked,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isActive: isActive,
            isHovered: isHovered,
            isInvalid: isInvalid
          }), isIndeterminate ? /*#__PURE__*/React.createElement(IconIndeterminate, {
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: tokens.icon.size,
            label: ""
          }) : /*#__PURE__*/React.createElement(Icon, {
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: tokens.icon.size,
            label: ""
          }));
        });
      }));
    }
  }]);

  return CheckboxIcon;
}(Component);

_defineProperty(CheckboxIcon, "defaultProps", {
  primaryColor: 'inherit',
  secondaryColor: 'inherit',
  isIndeterminate: false,
  theme: function theme(current, props) {
    return current(props);
  }
});

export { CheckboxIcon as default };